import { CommonModule } from '@angular/common';
import { Component, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { ProfileEditComponent } from 'src/app/shared/profile-edit/profile-edit.component';

@Component({
  selector: 'app-header',
  standalone: true,
  templateUrl: './header.component.html',
  encapsulation: ViewEncapsulation.None,
  imports: [
    CommonModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
  ],
})
export class HeaderComponent {
  @Output() toggleSidebar = new EventEmitter<void>();

  constructor(private dialog: MatDialog) {}

  openProfileEditDialog(): void {
    const dialogConfig: MatDialogConfig = {
      position: { top: '60px', right: '20px' },
      panelClass: 'custom-dialog-container',
      autoFocus: false,
      width: '350px',
      height: 'auto',
    };
    this.dialog.open(ProfileEditComponent, dialogConfig);
  }

  onToggleSidebar(): void {
    this.toggleSidebar.emit();
  }
}